import { render, staticRenderFns } from "./DateTimeFormat.vue?vue&type=template&id=1dcec6c8"
import script from "./DateTimeFormat.vue?vue&type=script&lang=js"
export * from "./DateTimeFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports